<template>
  <b-card no-body style="border: none;">
    <section class="section section-container bg-secondary">
      <div class="container px-0">
        <div class="row row-grid">
          <div class="col-md-12 col-lg-6">
            <div class="card bg-default shadow border-0 d-none d-lg-block">
              <img :src="actualImageUrl" class="card-img-top shadow rounded" height="400" alt="image" />
            </div>
          </div>
          <div class="col-md-12 col-lg-6">
            <div class="pl-md-2">
              <h3 class="text-primary">
                {{ product.name }}
              </h3>
              <p>
                {{ product.description }} <br />
                <span class="mr-2" style="font-weight: 900;">Project Name:</span>{{ product.projectName }} <br />
                <span class="mr-2" style="font-weight: 900;">Type:</span> {{ product.type }} <br />
                <span class="mr-2" style="font-weight: 900;">Client Name:</span> {{ product.clientName }} <br />
              </p>
              <img :src="productImageUrl" class="on-sm-text-center" width="300" alt="image" />
              <img :src="actualImageUrl" class="on-sm-text-center ml-md-4 mt-sm-4 d-lg-none" width="300" alt="image" />
            </div>
          </div>
        </div>
      </div>
    </section>
  </b-card>
</template>

<script>
import { BCardGroup } from "bootstrap-vue/esm/components/card/card-group";
import { BCard } from "bootstrap-vue/esm/components/card/card";

export default {
  name: "product-left",
  components: {
    BCardGroup,
    BCard,
  },

  props: {
    product: {
      type: Object,
      required: true,
      default: () => { },
    },
  },

  computed: {
    actualImageUrl() {
      return this.product.actualImage.url;
    },
    productImageUrl() {
      return this.product.productImage.url;
    },
  }
};
</script>

<style lang="scss" scoped>
/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {

  .section-container {
    padding-left: 20px;
    padding-right: 20px;
  }

  .on-sm-text-left {
    text-align: left !important;
  }

  .on-sm-text-center {
    text-align: center !important;
  }
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
  .hero {
    height: 500px;
  }
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .hero {
    height: 500px;
  }
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
  .hero {
    height: 500px;
  }
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
  .hero {
    height: 500px;
  }
}
</style>